// Email templates for campaigns

// Get base URL based on environment
const getBaseUrl = () => {
  // In Vite, use import.meta.env.DEV to check if we're in development
  if (import.meta.env.DEV) {
    return 'http://localhost:3000';
  }
  return 'https://axiosdevelopment.dev';
};

export const emailTemplates = [
  {
    id: 'redesign',
    campaignId: 'cm_rd_7f3a9b2e4d8c1a6f5e9b3d2c8a4f7e1b',
    name: 'Website Redesign',
    description: 'For clients who already have a website - interest them in a redesign',
    category: 'Existing Website',
    subject: 'We checked out your website - here\'s what we can do',
    html: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta name="color-scheme" content="light dark">
  <meta name="supported-color-schemes" content="light dark">
  <title>Website Redesign</title>
  <style type="text/css">
    /* Dark mode support for email clients that support it */
    @media (prefers-color-scheme: dark) {
      .email-container { background-color: #1a1a1a !important; }
      .email-body { background-color: #2a2a2a !important; }
      .email-content { color: #ffffff !important; }
      .email-header { background-color: #1a1c1b !important; }
      .email-footer { background-color: #302f2c !important; }
      .email-button { background-color: #d9fb06 !important; color: #000000 !important; }
      .email-border { border-color: #3f4816 !important; }
    }
    /* Light mode (default) - explicit for better compatibility */
    @media (prefers-color-scheme: light) {
      .email-container { background-color: #f4f4f4 !important; }
      .email-body { background-color: #ffffff !important; }
      .email-content { color: #000000 !important; }
      .email-button { background-color: #d9fb06 !important; color: #000000 !important; }
    }
    /* Fallback styles for clients that don't support media queries */
    .email-container { background-color: #f4f4f4; }
    .email-body { background-color: #ffffff; }
    .email-content { color: #000000; }
    .email-header { background-color: #1a1c1b; }
    .email-footer { background-color: #302f2c; }
    .email-button { background-color: #d9fb06; color: #000000; }
    .email-border { border-color: #3f4816; }
  </style>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f4f4f4;">
  <table width="100%" cellpadding="0" cellspacing="0" class="email-container" style="background-color: #f4f4f4;">
    <tr>
      <td align="center" style="padding: 20px 0;">
        <table width="600" cellpadding="0" cellspacing="0" class="email-body" style="background-color: #ffffff; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
          <!-- Header -->
          <tr>
            <td class="email-header" style="background-color: #1a1c1b; padding: 30px; text-align: center;">
              <h1 style="color: #d9fb06; margin: 0; font-size: 28px; font-weight: bold;">Axios Development</h1>
            </td>
          </tr>
          
          <!-- Main Content -->
          <tr>
            <td class="email-body" style="background-color: #ffffff; padding: 40px 30px;">
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                We've been looking at your business and your current website. We can make it way better.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                I know some agencies charge crazy prices — we keep things fair. You won't wait months with us — we build fast.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                You're going to love what we create. Fast, modern, and built to actually work for your business.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                <strong style="color: inherit;">Money-back guarantee.</strong> If you're not happy, you don't pay. Simple.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 30px 0;">
                Our pricing is flexible and based completely on your budget. Let's make it happen.
              </p>
              
              <!-- CTA Button -->
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td align="center" style="padding: 20px 0;">
                    <a href="${getBaseUrl()}/#contact?c=cm_rd_7f3a9b2e4d8c1a6f5e9b3d2c8a4f7e1b" class="email-button" style="background-color: #d9fb06; color: #000000; padding: 15px 40px; text-decoration: none; border-radius: 5px; font-weight: bold; font-size: 16px; display: inline-block;">
                      Let's Talk
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td class="email-footer" style="background-color: #302f2c; padding: 40px 30px; text-align: center;">
              <div class="email-border" style="border-top: 2px solid #3f4816; padding-top: 30px; margin-top: 20px;">
                <p style="color: #d9fb06; font-size: 18px; font-weight: bold; margin: 0 0 5px 0; letter-spacing: 1px;">
                  Team at Axios
                </p>
                <p style="color: #888680; font-size: 12px; margin: 10px 0 0 0;">
                  Building digital excellence since 2014
                </p>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `,
  },
  {
    id: 'new-site',
    campaignId: 'cm_ns_9a2f4e7c3b8d1e6f5a9c2d7e4b8f1a3c',
    name: 'New Website',
    description: 'For clients with no website - introduce them to getting started',
    category: 'No Website',
    subject: 'We checked out your business - you need a website',
    html: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta name="color-scheme" content="light dark">
  <meta name="supported-color-schemes" content="light dark">
  <title>New Website</title>
  <style type="text/css">
    /* Dark mode support for email clients that support it */
    @media (prefers-color-scheme: dark) {
      .email-container { background-color: #1a1a1a !important; }
      .email-body { background-color: #2a2a2a !important; }
      .email-content { color: #ffffff !important; }
      .email-header { background-color: #1a1c1b !important; }
      .email-footer { background-color: #302f2c !important; }
      .email-button { background-color: #d9fb06 !important; color: #000000 !important; }
      .email-border { border-color: #3f4816 !important; }
    }
    /* Light mode (default) - explicit for better compatibility */
    @media (prefers-color-scheme: light) {
      .email-container { background-color: #f4f4f4 !important; }
      .email-body { background-color: #ffffff !important; }
      .email-content { color: #000000 !important; }
      .email-button { background-color: #d9fb06 !important; color: #000000 !important; }
    }
    /* Fallback styles for clients that don't support media queries */
    .email-container { background-color: #f4f4f4; }
    .email-body { background-color: #ffffff; }
    .email-content { color: #000000; }
    .email-header { background-color: #1a1c1b; }
    .email-footer { background-color: #302f2c; }
    .email-button { background-color: #d9fb06; color: #000000; }
    .email-border { border-color: #3f4816; }
  </style>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f4f4f4;">
  <table width="100%" cellpadding="0" cellspacing="0" class="email-container" style="background-color: #f4f4f4;">
    <tr>
      <td align="center" style="padding: 20px 0;">
        <table width="600" cellpadding="0" cellspacing="0" class="email-body" style="background-color: #ffffff; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
          <!-- Header -->
          <tr>
            <td class="email-header" style="background-color: #1a1c1b; padding: 30px; text-align: center;">
              <h1 style="color: #d9fb06; margin: 0; font-size: 28px; font-weight: bold;">Axios Development</h1>
            </td>
          </tr>
          
          <!-- Main Content -->
          <tr>
            <td class="email-body" style="background-color: #ffffff; padding: 40px 30px;">
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                Hey! I know you're probably comparing web development agencies, so I wanted to reach out personally about getting you a website.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                We've been looking at your business. You don't have a website yet, and you're missing out on customers because of it.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                We build beautiful websites quickly, and make the whole process simple so you never feel overwhelmed. We handle everything.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                You're going to love what we create. Clean, fast, and built to bring in customers.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                <strong style="color: inherit;">Money-back guarantee.</strong> If you're not happy, you don't pay. Simple.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 30px 0;">
                Our pricing is flexible and based completely on your budget. Let's make it happen.
              </p>
              
              <!-- CTA Button -->
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td align="center" style="padding: 20px 0;">
                    <a href="${getBaseUrl()}/#contact?c=cm_ns_9a2f4e7c3b8d1e6f5a9c2d7e4b8f1a3c" class="email-button" style="background-color: #d9fb06; color: #000000; padding: 15px 40px; text-decoration: none; border-radius: 5px; font-weight: bold; font-size: 16px; display: inline-block;">
                      Let's Build It
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td class="email-footer" style="background-color: #302f2c; padding: 40px 30px; text-align: center;">
              <div class="email-border" style="border-top: 2px solid #3f4816; padding-top: 30px; margin-top: 20px;">
                <p style="color: #d9fb06; font-size: 18px; font-weight: bold; margin: 0 0 5px 0; letter-spacing: 1px;">
                  Team at Axios
                </p>
                <p style="color: #888680; font-size: 12px; margin: 10px 0 0 0;">
                  Building digital excellence since 2014
                </p>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `,
  },
  {
    id: 'follow-up',
    campaignId: 'cm_fu_5b8e3d1a9f2c7e4b6a8d3f1c9e5b2a7d',
    name: 'Follow Up',
    description: 'Follow up with leads who have shown interest',
    category: 'Follow Up',
    subject: 'Following up on your interest',
    requiresContactName: true,
    html: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta name="color-scheme" content="light dark">
  <meta name="supported-color-schemes" content="light dark">
  <title>Follow Up</title>
  <style type="text/css">
    /* Dark mode support for email clients that support it */
    @media (prefers-color-scheme: dark) {
      .email-container { background-color: #1a1a1a !important; }
      .email-body { background-color: #2a2a2a !important; }
      .email-content { color: #ffffff !important; }
      .email-header { background-color: #1a1c1b !important; }
      .email-footer { background-color: #302f2c !important; }
      .email-button { background-color: #d9fb06 !important; color: #000000 !important; }
      .email-border { border-color: #3f4816 !important; }
    }
    /* Light mode (default) - explicit for better compatibility */
    @media (prefers-color-scheme: light) {
      .email-container { background-color: #f4f4f4 !important; }
      .email-body { background-color: #ffffff !important; }
      .email-content { color: #000000 !important; }
      .email-button { background-color: #d9fb06 !important; color: #000000 !important; }
    }
    /* Fallback styles for clients that don't support media queries */
    .email-container { background-color: #f4f4f4; }
    .email-body { background-color: #ffffff; }
    .email-content { color: #000000; }
    .email-header { background-color: #1a1c1b; }
    .email-footer { background-color: #302f2c; }
    .email-button { background-color: #d9fb06; color: #000000; }
    .email-border { border-color: #3f4816; }
  </style>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f4f4f4;">
  <table width="100%" cellpadding="0" cellspacing="0" class="email-container" style="background-color: #f4f4f4;">
    <tr>
      <td align="center" style="padding: 20px 0;">
        <table width="600" cellpadding="0" cellspacing="0" class="email-body" style="background-color: #ffffff; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
          <!-- Header -->
          <tr>
            <td class="email-header" style="background-color: #1a1c1b; padding: 30px; text-align: center;">
              <h1 style="color: #d9fb06; margin: 0; font-size: 28px; font-weight: bold;">Axios Development</h1>
            </td>
          </tr>
          
          <!-- Main Content -->
          <tr>
            <td class="email-body" style="background-color: #ffffff; padding: 40px 30px;">
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                Hey, {{CONTACT_NAME}}!
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                I wanted to follow up personally on your interest in website development. We're ready to help you get started.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                Let's talk about what you need and how we can make it happen. We handle everything so you don't feel overwhelmed.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                <strong style="color: inherit;">Money-back guarantee.</strong> If you're not happy, you don't pay. Simple.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 30px 0;">
                Our pricing is flexible and based completely on your budget. Let's make it happen.
              </p>
              
              <!-- CTA Button -->
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td align="center" style="padding: 20px 0;">
                    <a href="${getBaseUrl()}/#contact?c=cm_fu_5b8e3d1a9f2c7e4b6a8d3f1c9e5b2a7d" class="email-button" style="background-color: #d9fb06; color: #000000; padding: 15px 40px; text-decoration: none; border-radius: 5px; font-weight: bold; font-size: 16px; display: inline-block;">
                      Let's Talk
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td class="email-footer" style="background-color: #302f2c; padding: 40px 30px; text-align: center;">
              <div class="email-border" style="border-top: 2px solid #3f4816; padding-top: 30px; margin-top: 20px;">
                <p style="color: #d9fb06; font-size: 18px; font-weight: bold; margin: 0 0 5px 0; letter-spacing: 1px;">
                  Team at Axios
                </p>
                <p style="color: #888680; font-size: 12px; margin: 10px 0 0 0;">
                  Building digital excellence since 2014
                </p>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `,
  },
  {
    id: 'cold-outreach',
    campaignId: 'cm_co_8c9f2a4e7d3b1a6f5e9c2d8a4b7f1e3c',
    name: 'Cold Outreach',
    description: 'Cold outreach introducing who we are and offering a free demo',
    category: 'Cold Outreach',
    subject: 'Free website demo - no obligation',
    requiresContactName: true,
    html: `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta name="color-scheme" content="light dark">
  <meta name="supported-color-schemes" content="light dark">
  <title>Cold Outreach</title>
  <style type="text/css">
    /* Dark mode support for email clients that support it */
    @media (prefers-color-scheme: dark) {
      .email-container { background-color: #1a1a1a !important; }
      .email-body { background-color: #2a2a2a !important; }
      .email-content { color: #ffffff !important; }
      .email-header { background-color: #1a1c1b !important; }
      .email-footer { background-color: #302f2c !important; }
      .email-button { background-color: #d9fb06 !important; color: #000000 !important; }
      .email-border { border-color: #3f4816 !important; }
    }
    /* Light mode (default) - explicit for better compatibility */
    @media (prefers-color-scheme: light) {
      .email-container { background-color: #f4f4f4 !important; }
      .email-body { background-color: #ffffff !important; }
      .email-content { color: #000000 !important; }
      .email-button { background-color: #d9fb06 !important; color: #000000 !important; }
    }
    /* Fallback styles for clients that don't support media queries */
    .email-container { background-color: #f4f4f4; }
    .email-body { background-color: #ffffff; }
    .email-content { color: #000000; }
    .email-header { background-color: #1a1c1b; }
    .email-footer { background-color: #302f2c; }
    .email-button { background-color: #d9fb06; color: #000000; }
    .email-border { border-color: #3f4816; }
  </style>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f4f4f4;">
  <table width="100%" cellpadding="0" cellspacing="0" class="email-container" style="background-color: #f4f4f4;">
    <tr>
      <td align="center" style="padding: 20px 0;">
        <table width="600" cellpadding="0" cellspacing="0" class="email-body" style="background-color: #ffffff; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
          <!-- Header -->
          <tr>
            <td class="email-header" style="background-color: #1a1c1b; padding: 30px; text-align: center;">
              <h1 style="color: #d9fb06; margin: 0; font-size: 28px; font-weight: bold;">Axios Development</h1>
            </td>
          </tr>
          
          <!-- Main Content -->
          <tr>
            <td class="email-body" style="background-color: #ffffff; padding: 40px 30px;">
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                Hello {{CONTACT_NAME}},
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                We make websites, modern, fast, and built to help your business grow.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                Can we give you a free demo? No obligation. We'll show you what we can do for your business and how we can help you stand out online.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                We build beautiful websites quickly, and make the whole process simple so you never feel overwhelmed. We handle everything.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                You're going to love what we create. Clean, fast, and built to bring in customers.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 20px 0;">
                <strong style="color: inherit;">Money-back guarantee.</strong> If you're not happy, you don't pay. Simple.
              </p>
              
              <p class="email-content" style="color: #000000; font-size: 16px; line-height: 1.6; margin: 0 0 30px 0;">
                Our pricing is flexible and based completely on your budget. Interested in seeing what we can do? Let's set up a quick demo. No pressure, no commitment, just a chance to see how we can help.
              </p>
              
              <!-- CTA Button -->
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td align="center" style="padding: 20px 0;">
                    <a href="${getBaseUrl()}/#contact?c=cm_co_8c9f2a4e7d3b1a6f5e9c2d8a4b7f1e3c" class="email-button" style="background-color: #d9fb06; color: #000000; padding: 15px 40px; text-decoration: none; border-radius: 5px; font-weight: bold; font-size: 16px; display: inline-block;">
                      Get Free Demo
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- Footer -->
          <tr>
            <td class="email-footer" style="background-color: #302f2c; padding: 40px 30px; text-align: center;">
              <div class="email-border" style="border-top: 2px solid #3f4816; padding-top: 30px; margin-top: 20px;">
                <p style="color: #d9fb06; font-size: 18px; font-weight: bold; margin: 0 0 5px 0; letter-spacing: 1px;">
                  Team at Axios
                </p>
                <p style="color: #888680; font-size: 12px; margin: 10px 0 0 0;">
                  Building digital excellence since 2014
                </p>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `,
  },
];
